import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { isAPIError } from '@/store/utils';
import type { LoginDTO, LoginResult, LoginReturn } from '@/types/DTOs';
import { setUkek } from '@/store/slices/auth/authSlice';
import { getUserIdFromToken } from '@/store/utils/jwtDecoder';
import { setUkekInStorage } from '@/utils/sessionStorage';

const mapCredentialVerificationResult = (result: LoginResult): LoginReturn => ({
  twoFactorToken: result.twoFactorToken,
});

export const credentialVerificationThunk = createAppAsyncThunk<LoginReturn, LoginDTO>(
  'auth/login',
  async(credentials, { dispatch, extra: { authService, pocServices: { cryptoService } }, rejectWithValue }) => {
    const normalizedCredentials = { ...credentials, username: credentials.username.toLowerCase() };
    try {
        const result = await authService.login(normalizedCredentials);
        const mappedResult = mapCredentialVerificationResult(result);
        const userId = getUserIdFromToken(mappedResult.twoFactorToken);
        const ukek = await cryptoService.deriveKey(
          normalizedCredentials.password,
          normalizedCredentials.username
        );

        dispatch(setUkek(ukek));
        if (userId !== null) {
          setUkekInStorage(userId, ukek);
        }

        return mappedResult;
    } catch (error) {
      if (isAPIError(error) && error.fieldErrors != null) {
        return rejectWithValue({ fieldErrors: error.fieldErrors });
      }
      throw error;
    }
  }
);
